import http from "./http-common";
import GalleryModel from "../models/gallery";
import qs from "qs";

// Navbar APIs
// eslint-disable-next-line
export default new (class GalleryService {
  // Get all
  async getGalleryBySize({ page = 1, pageSize = 5, sort = "desc" }) {
    const query = qs.stringify(
      {
        sort: [`publishedAt:${sort}`],
        pLevel: 5,
        pagination: {
          page: page,
          pageSize: pageSize,
        },
      },
      {
        encodeValuesOnly: true,
      }
    );
    return await http
      .get("/albums?" + query)
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((gallery) => GalleryModel.get(gallery))
        );

        const meta = response.data.meta;

        return [data, meta];
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async getGalleryBySlug(slug) {
    // ให้ Strapi กรองด้วย slug — ถ้าดึงมาทั้งหมดแล้วค่อยหา จะได้แค่ 25 รายการแรก
    // อัลบั้มที่เกินนั้นจะหาไม่เจอแล้วเด้งกลับหน้า gallery
    const query = qs.stringify(
      { filters: { Slug: { $eq: slug } }, pLevel: 5 },
      { encodeValuesOnly: true }
    );
    return await http
      .get("/albums?" + query)
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((gallery) => GalleryModel.get(gallery))
        );

        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async getAnotherGallery(slug) {
    // เดิมกรอง id != slug ซึ่งไม่ตรงชนิดกัน เลยไม่ได้ตัดอัลบั้มที่กำลังดูอยู่ออก
    const query = qs.stringify(
      {
        filters: { Slug: { $ne: slug } },
        sort: ["publishedAt:desc"],
        pLevel: 5,
        pagination: { page: 1, pageSize: 3 },
      },
      { encodeValuesOnly: true }
    );
    return await http
      .get("/albums?" + query)
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((gallery) => GalleryModel.get(gallery))
        );

        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async getGalleryByTag({ sort = "desc", tag = "" }) {
    const query = qs.stringify(
      {
        filters: {
          $and: [
            {
              tag: {
                tag: {
                  $eq: tag,
                },
              },
            },
          ],
        },
        sort: [`publishedAt:${sort}`],
        pLevel: 5,
      },
      {
        encodeValuesOnly: true,
      }
    );
    return await http
      .get("/albums?" + query)
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((gallery) => GalleryModel.get(gallery))
        );

        return [data];
      })
      .catch((error) => {
        console.log(error);
      });
  }
})();
